export default "__VITE_ASSET__4oq0GPLG__"